import coreAPIInstance from "./coreApiInstance";

export const captureAPIs = {
  getCaptureImages: ({ payload }) => coreAPIInstance.get(`/api/capture/search`, payload),
};
